import { FC, ReactElement } from 'react'

import { IconButton } from '@/compositions'
import { trans } from '@/helpers/trans'

import './NewConversationButton.scss'

interface NewConversationButtonProps {
    onClick: () => void
}

export const NewConversationButton: FC<NewConversationButtonProps> = ({
    onClick,
}): ReactElement => (
    <div className="new-conversation-button">
        <IconButton
            hideLabel
            icon="plus"
            text={trans('pages.messages.newChat')}
            onClick={onClick}
            className="new-conversation-button__button"
        />
    </div>
)
